<template>
  <!--  서브페이지  -->

  <!--콘텐츠 영역-->
  <div id="sub_contents" class="sub_contents">
    <a href="#sub_area" id="top_btn"></a>
    <div class="item ">
      
      <div class="tit">
        <h3 class="fNS-EB">홍보영상</h3>
      </div>
      <div class="txt">
        
        <p class="pdb50">
          <iframe
            width="825px"
            height="462px"
            src="https://www.youtube.com/embed/FaM4bWRyVkI"
            frameborder="0"
            allow="accelerometer; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen="allowfullscreen"
          ></iframe>
        </p>
        
        <p class="pdt30 ">
          <iframe
            width="825px"
            height="462px"
            src="https://www.youtube.com/embed/eSsOzzTchKc"
            frameborder="0"
            allow="accelerometer; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen="allowfullscreen"
          ></iframe>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data: () => ({
    message: "PRVideo.vue"
  }),
  methods: {},
  computed: {},
  destroyed() {},
  created() {
    console.log("created - " + this.message);
  }
};
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/sub03/PRVideo.vue